/**
 * Soomro Foods — Favorites / Wishlist System
 * Stores favorites in localStorage. Dispatches 'favorites:changed' on every mutation.
 */
(function () {
  const STORAGE_KEY = 'soomro_favorites';

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('favorites:changed', { detail: { items } }));
  }

  window.SoomroFavorites = {
    getAll()       { return load(); },
    count()        { return load().length; },
    isFavorited(id){ return load().some(p => String(p.id) === String(id)); },
    add(product) {
      const items = load();
      if (!items.some(p => String(p.id) === String(product.id))) { items.push(product); save(items); }
    },
    remove(id) { save(load().filter(p => String(p.id) !== String(id))); },
    toggle(product) {
      if (this.isFavorited(product.id)) { this.remove(product.id); return false; }
      else { this.add(product); return true; }
    }
  };

  /* ── Sync all heart buttons on page with stored state ── */
  function syncHearts() {
    document.querySelectorAll('[data-fav-btn]').forEach(btn => {
      const isFav = window.SoomroFavorites.isFavorited(btn.getAttribute('data-product-id'));
      btn.classList.toggle('is-favorited', isFav);
      btn.setAttribute('aria-label', isFav ? 'Remove from favorites' : 'Add to favorites');
    });
  }

  /* ── Update header badge count ── */
  function updateBadge() {
    const count = window.SoomroFavorites.count();
    document.querySelectorAll('.fav-badge').forEach(b => {
      b.textContent = count;
      b.setAttribute('data-count', String(count));
      if (count > 0) {
        b.style.setProperty('display', 'flex', 'important');
      } else {
        b.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* ── Render products inside drawer ── */
  function formatPrice(p) { return p || ''; }

  function renderDrawerItems() {
    const container = document.getElementById('fav-drawer-items');
    const empty     = document.getElementById('fav-drawer-empty');
    const countEl   = document.getElementById('fav-drawer-count');
    if (!container) return;
    const items = window.SoomroFavorites.getAll();
    if (countEl) countEl.textContent = items.length;
    if (items.length === 0) {
      container.innerHTML = '';
      if (empty) empty.style.display = 'flex';
      return;
    }
    if (empty) empty.style.display = 'none';
    container.innerHTML = items.map(p => `
      <div class="fav-item" data-fav-item-id="${p.id}">
        <a href="${p.url}" class="fav-item__image-wrap">
          <img src="${p.image}" alt="${p.title}" loading="lazy" />
        </a>
        <div class="fav-item__info">
          <a href="${p.url}" class="fav-item__title">${p.title}</a>
          <p class="fav-item__price">${formatPrice(p.price)}</p>
          <div class="fav-item__actions">
            <a href="${p.url}" class="fav-item__view-btn">View Product</a>
            <button class="fav-item__remove-btn" onclick="window.SoomroFavorites.remove('${p.id}')" aria-label="Remove from favorites">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              Remove
            </button>
          </div>
        </div>
      </div>`).join('');
  }

  /* ── React to any favorites change ── */
  document.addEventListener('favorites:changed', () => { syncHearts(); updateBadge(); renderDrawerItems(); });

  /* ── Heart button click (delegated) ── */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-fav-btn]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const product = {
      id:    btn.getAttribute('data-product-id'),
      title: btn.getAttribute('data-product-title'),
      price: btn.getAttribute('data-product-price'),
      image: btn.getAttribute('data-product-image'),
      url:   btn.getAttribute('data-product-url'),
    };
    const isFav = window.SoomroFavorites.toggle(product);
    btn.classList.toggle('is-favorited', isFav);
    btn.setAttribute('aria-label', isFav ? 'Remove from favorites' : 'Add to favorites');
    btn.classList.add('fav-pulse');
    setTimeout(() => btn.classList.remove('fav-pulse'), 400);
  });

  /* ── Drawer open / close ── */
  document.addEventListener('click', function(e) {
    if (e.target.closest('.header__icon--wishlist')) { 
      e.preventDefault(); 
      
      // Close main header drawer cleanly if open
      const headerDrawer = document.querySelector('header-drawer');
      if (headerDrawer) {
        const closeBtn = headerDrawer.querySelector('.drawer-close-btn') || headerDrawer.querySelector('summary');
        if (typeof headerDrawer.closeMenuDrawer === 'function' && closeBtn) {
          headerDrawer.closeMenuDrawer(null, closeBtn);
        } else {
          const mainDetails = headerDrawer.querySelector('details');
          if (mainDetails) {
            mainDetails.removeAttribute('open');
            mainDetails.classList.remove('menu-opening');
          }
        }
      }
      
      // Clean up header menu drawer body overflow lock classes
      document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
      document.body.style.overflow = '';

      openFavDrawer(); 
      return;
    }

    if (e.target.closest('#fav-drawer-close') || e.target.closest('#fav-drawer-overlay')) { 
      closeFavDrawer(); 
      return;
    }

    // Tap outside to close Wishlist sidebar
    if (document.body.classList.contains('fav-drawer-open')) {
      const favDrawer = document.getElementById('fav-drawer');
      if (favDrawer && !favDrawer.contains(e.target)) {
        closeFavDrawer();
      }
    }
  });

  function openFavDrawer() {
    const drawer = document.getElementById('fav-drawer');
    if (!drawer) return;
    renderDrawerItems();
    drawer.classList.add('is-open');
    document.body.classList.add('fav-drawer-open');
  }

  function closeFavDrawer() {
    const drawer = document.getElementById('fav-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('fav-drawer-open', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  /* ── Init ── */
  function initDesktopWishlistButton() {
    // Direct click listener on the desktop header wishlist button
    // This bypasses event delegation in case other handlers stop propagation
    var desktopBtn = document.getElementById('mobile-header-wishlist-icon');
    if (desktopBtn && !desktopBtn._favBound) {
      desktopBtn._favBound = true;
      desktopBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openFavDrawer();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { 
      syncHearts(); updateBadge(); initDesktopWishlistButton(); 
    });
  } else {
    syncHearts(); updateBadge(); initDesktopWishlistButton();
  }
})();
